import React, { ReactNode } from 'react';

interface AdminLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}

/**
 * AdminLayout provides the content wrapper for admin pages.
 *
 * NOTE (T-385): The sidebar is now handled by UnifiedSidebar in MainLayout.
 * This component only provides the content area with header and styling.
 * The UnifiedSidebar automatically detects admin routes and shows admin navigation.
 */
const AdminLayout = ({ title, description, children }: AdminLayoutProps) => {
  return (
    <div className="min-h-full bg-slate-50 dark:bg-gray-950">
      <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 md:px-10 md:py-10">
        {/* AR-210 (TC-36.1): the page title is the page's h1 (the sidebar label no longer is). */}
        <div className="mb-6 md:mb-8">
          <p className="text-sm font-semibold uppercase tracking-wide text-orange-600 dark:text-orange-400">Admin</p>
          <h1 className="mt-2 text-2xl font-semibold text-slate-900 dark:text-slate-100 md:text-3xl">{title}</h1>
          {description && (
            <p className="mt-2 max-w-3xl text-sm text-slate-600 dark:text-slate-400 md:text-base">
              {description}
            </p>
          )}
        </div>
        <section className="min-h-[60vh]">
          {children}
        </section>
      </div>
    </div>
  );
};

export default AdminLayout;
